// extracted by mini-css-extract-plugin
export default {"box":"IconCard-module__box-AdoE","title":"IconCard-module__title-RiTi","graphic":"IconCard-module__graphic-OxFW","chargesList":"IconCard-module__chargesList-GUfV"};